
import React, { memo } from 'react';
import { UserCog } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/auth';
import { useLanguage } from '@/contexts/LanguageContext';
import { useUserAllowedRoles } from '@/hooks/useUserAllowedRoles';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const RoleSelector: React.FC = memo(() => {
  const { profile, updateRole } = useAuth();
  const { t } = useLanguage();
  const { allowedRoles, loading } = useUserAllowedRoles();
  
  const getRoleLabel = (role: 'student' | 'teacher' | 'admin') => {
    switch (role) {
      case 'student':
        return t('Žák', 'Žiak');
      case 'teacher':
        return t('Učitel', 'Učiteľ');
      case 'admin':
        return t('Správce', 'Správca');
      default:
        return t('Role', 'Rola');
    }
  };

  // Pokud nemá uživatel žádné povolené role nebo pouze jednu, nezobraí se selector
  if (loading || allowedRoles.length <= 1) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="flex items-center gap-1 h-9">
          <UserCog className="h-4 w-4 mr-1" />
          {profile?.role ? getRoleLabel(profile.role) : t('Role', 'Rola')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {allowedRoles.map((role) => (
          <DropdownMenuItem 
            key={role}
            disabled={profile?.role === role} 
            onClick={() => profile && updateRole(role)}
            className="cursor-pointer"
          >
            {getRoleLabel(role)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
});

RoleSelector.displayName = 'RoleSelector';

export default RoleSelector;
